import Base from "@/layouts/Base.vue";

export default [
    {
        path: "/",
        name: "baseLayout",
        component: Base,
        children: [
            {
                path: "/login",
                name: "login",
                meta: {middleware: "guest"},
                component: () => import("../views/auth/Login.vue"),
            },
            {
                path: "/ekyzmat",
                name: "ekyzmat",
                meta: {middleware: "guest"},
                component: () => import("../views/auth/Ekyzmat.vue"),
            },
        ],
    },
    {
        path: "/:catchAll(.*)",
        name: "404",
        redirect: {
            name: "home",
        },
    },
];
